import React, { useEffect, useState } from 'react';
import { Space, Card, Button, Modal, Divider, Drawer, Alert, Flex } from 'antd';
import InputNumber from 'components/input-number';
import { formatCurrency } from 'utils/number';

const PriceEdit = ({ value = [], onChange, original_price = 0, onChangeAll, disabled = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pricelist, setPriceList] = useState([]);

  useEffect(() => {
    setPriceList([...(value || [])]);
  }, [value]);

  const handleOk = () => {
    setIsModalOpen(false);
    onChange(pricelist);
  };

  const onAddPrice = () => {
    if (pricelist.length > 0) {
      const last = pricelist[pricelist.length - 1];
      const newPrices = { min: last.max, max: last.max + 10, price: last.price - 10000 };
      setPriceList([...pricelist, newPrices]);
    } else {
      const newPrices = { min: 1, max: 5, price: original_price };
      setPriceList([...pricelist, newPrices]);
    }
  };

  const deletePriceAt = (index) => {
    const newPriceList = [...pricelist];
    newPriceList.splice(index, 1);
    setPriceList(newPriceList);
  };

  const updatePriceAt = (index, name, nextValue) => {
    const newPriceList = [...pricelist];
    newPriceList[index][name] = nextValue;
    setPriceList(newPriceList);
  };

  const btnAllClick = () => {
    setIsModalOpen(false);
    onChangeAll(pricelist);
  };

  return (
    <>
      {!disabled && <Button type='link' onClick={() => setIsModalOpen(true)}>Sửa giá theo SL</Button>}
      <Modal
        title='Sửa giá theo số lượng'
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        width='calc(100vw - 24px)'
        style={{ maxWidth: 520 }}
        bodyStyle={{ maxHeight: '60vh', overflowY: 'auto', paddingTop: 8 }}
        footer={
          <Space wrap style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={onAddPrice}>Thêm khoảng giá</Button>
            <Button onClick={btnAllClick}>Áp dụng chung</Button>
            <Button type='primary' onClick={handleOk}>Áp dụng</Button>
          </Space>
        }
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          {(pricelist || []).map((row, index) => (
            <div key={index}>
              <Space direction='vertical' style={{ width: '100%' }} size={6}>
                <div style={{ fontSize: 12, opacity: 0.8 }}>Khoảng giá #{index + 1}</div>
                <div>
                  <div>Từ</div>
                  <InputNumber value={row?.min} onChange={(e) => updatePriceAt(index, 'min', e)} showCalculator={false} style={{ width: '100%' }} />
                </div>
                <div>
                  <div>Giá</div>
                  <InputNumber value={row?.price} onChange={(e) => updatePriceAt(index, 'price', e)} style={{ width: '100%' }} />
                </div>
                <Button type='link' danger size='small' onClick={() => deletePriceAt(index)}>Xoá</Button>
              </Space>
              {index < (pricelist || []).length - 1 && <Divider style={{ margin: '12px 0' }} />}
            </div>
          ))}

          {(pricelist || []).length === 0 && (
            <div style={{ opacity: 0.75 }}>Chưa có khoảng giá. Nhấn "Thêm khoảng giá" để bắt đầu.</div>
          )}
        </Space>
      </Modal>
    </>
  );
};

const PriceOriginalEdit = ({ value = 0, onChange, onChangeAll, disabled = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    setPrice(value || 0);
  }, [value]);

  const handleOk = () => {
    setIsModalOpen(false);
    onChange(price);
  };

  const btnAllClick = () => {
    setIsModalOpen(false);
    onChangeAll(price);
  };

  return (
    <>
      {!disabled && <Button type='link' onClick={() => setIsModalOpen(true)}>Sửa giá bán</Button>}
      <Modal
        title='Sửa giá bán'
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        footer={
          <Space wrap style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={btnAllClick}>Áp dụng chung</Button>
            <Button type='primary' onClick={handleOk}>Áp dụng</Button>
          </Space>
        }
      >
        <InputNumber value={price} onChange={(e) => setPrice(e)} style={{ width: '100%' }} />
      </Modal>
    </>
  );
};

const Mobile = ({ viewModel, embedded = false }) => {
  const {
    id,
    productVariants,
    pricingEnabled,
    sourceOptions,
    selectedSourceKey,
    setSelectedSourceKey,
    selectedTable,
    isTableSource,
    isTableManualMode,
    isTableAutoMode,
    navigate,
    onUpdateProductVariantPriceList,
    onVariantPriceListChange,
    onAllVariantPriceListChange,
    onVariantOriginalPriceChange,
    onAllVariantOriginalPriceChange,
  } = viewModel;
  const [openPriceSourcePicker, setOpenPriceSourcePicker] = useState(false);

  const selectedSourceLabel = (sourceOptions || []).find((x) => x?.value === selectedSourceKey)?.label;
  const priceTableCount = Math.max(0, (sourceOptions || []).length - 1);
  const hasMultiplePriceTables = priceTableCount > 1;

  const priceCardTitle = (
    <Space direction='vertical' size={8} style={{ width: '100%' }}>
      {!(pricingEnabled && hasMultiplePriceTables) && <div style={{ fontWeight: 600 }}>Giá sản phẩm</div>}
      {pricingEnabled && (
        <div>
          <Button
            type='text'
            style={{ padding: 0, fontWeight: 500, height: 'auto' }}
            onClick={() => setOpenPriceSourcePicker(true)}
          >
            {`Giá: ${selectedSourceLabel || 'Giá sản phẩm gốc'}`}
          </Button>
        </div>
      )}
    </Space>
  );

  return (
    <>
      <Space direction='vertical' size={12} style={{ width: '100%', paddingBottom: embedded ? 0 : 96 }}>
        <Card size='small' title={priceCardTitle}>
          {isTableSource && (
            <Alert
              type='info'
              showIcon
              message={`Đang chỉnh theo bảng giá: ${selectedTable?.name || ''}`}
              style={{ marginBottom: 12 }}
            />
          )}
          {isTableAutoMode && <Alert type='warning' showIcon message='Bảng giá tự động chỉ xem theo rule hiện có, không chỉnh sửa tại đây' style={{ marginBottom: 12 }} />}

          <Space direction='vertical' size={12} style={{ width: '100%' }}>
            {(productVariants || []).map((variant, index) => (
              <div key={variant?.id || variant?.variant_id || index}>
                <Space direction='vertical' size={6} style={{ width: '100%' }}>
                  <div><b>Biến thể:</b> {variant?.variant_title || '-'}</div>
                  <div><b>Giá bán:</b> {formatCurrency(variant?.original_price)}</div>
                  <PriceOriginalEdit
                    value={variant?.original_price ?? 0}
                    onChange={(e) => onVariantOriginalPriceChange(e, variant?.id || variant?.variant_id)}
                    onChangeAll={onAllVariantOriginalPriceChange}
                    disabled={isTableAutoMode}
                  />

                  <div>
                    <b>Giá theo số lượng:</b>
                    <Space direction='vertical' size={2} style={{ width: '100%', marginTop: 4 }}>
                      {(variant?.price_list || []).map((x, i) => (
                        <div key={`${x.min}-${x.price}-${i}`}>
                          Từ {x.min} - <b>{formatCurrency(x.price)}</b> - Giảm {formatCurrency((x.price - variant?.original_price) * -1)}
                        </div>
                      ))}
                      {(variant?.price_list || []).length === 0 && <div>-</div>}
                    </Space>
                  </div>

                  <PriceEdit
                    value={variant?.price_list ?? []}
                    original_price={variant?.original_price}
                    onChange={(e) => onVariantPriceListChange(e, variant?.id || variant?.variant_id)}
                    onChangeAll={onAllVariantPriceListChange}
                    disabled={isTableAutoMode}
                  />
                </Space>
                {index < (productVariants || []).length - 1 && <Divider style={{ margin: '10px 0' }} />}
              </div>
            ))}
          </Space>
        </Card>
      </Space>

      {embedded ? (
        <Flex justify='flex-end'>
          <Button type='primary' disabled={isTableAutoMode} onClick={onUpdateProductVariantPriceList}>
            {isTableAutoMode ? 'Cập nhật rule' : isTableManualMode ? 'Cập nhật bảng giá' : 'Cập nhật'}
          </Button>
        </Flex>
      ) : (
        <div
          style={{
            position: 'fixed',
            left: 12,
            right: 12,
            bottom: 12,
            zIndex: 1000,
            background: '#fff',
            border: '1px solid #f0f0f0',
            borderRadius: 12,
            padding: 12,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          }}
        >
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Button onClick={() => navigate(`/product/edit/${id}`)}>Back</Button>
            <Button type='primary' disabled={isTableAutoMode} onClick={onUpdateProductVariantPriceList}>
              {isTableAutoMode ? 'Cập nhật rule' : isTableManualMode ? 'Cập nhật bảng giá' : 'Cập nhật'}
            </Button>
          </Space>
        </div>
      )}

      <Drawer
        title='Chọn nguồn giá'
        placement='bottom'
        height='60vh'
        open={openPriceSourcePicker}
        onClose={() => setOpenPriceSourcePicker(false)}
      >
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {(sourceOptions || []).map((item) => (
            <Button
              key={item?.value}
              block
              size='large'
              type={item?.value === selectedSourceKey ? 'primary' : 'default'}
              onClick={() => {
                setSelectedSourceKey(item?.value);
                setOpenPriceSourcePicker(false);
              }}
            >
              {item?.label}
            </Button>
          ))}
        </Space>
      </Drawer>
    </>
  );
};

export default Mobile;

